'use client';

import { useIntl } from 'react-intl';

import messages from '@/components/authForm/ModeToggleRefresh/messages';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAnalytics } from '@/hooks/analytics';
import genericMessages from '@/messages/messages';

import { type MessageNode } from '../utils';
import { Cta, Wrapper } from './styles';

export type AuthPromptToggleProps = {
	/**
	 * @defaultValue
	 * ```tsx
	 * "sisu-auth-prompt-toggle"
	 * ```
	 */
	'data-testid'?: string;

	toggleText?: MessageNode;
	ctaText?: MessageNode;
};

export default function AuthPromptToggle({
	'data-testid': testId = 'sisu-auth-prompt-toggle',
	toggleText,
	ctaText,
}: AuthPromptToggleProps) {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();
	const { authPrompt, setAuthPrompt } = useAuthPrompt();

	const handleClick = () => {
		const newAuthPrompt = authPrompt === 'login' ? 'signup' : 'login';
		logEvent({
			eventName: 'Login Form : Mode : Toggled',
			eventProps: {
				mode: newAuthPrompt,
			},
		});
		setAuthPrompt(newAuthPrompt);
	};

	if (!toggleText) {
		toggleText = formatMessage(authPrompt === 'login' ? messages.loginToggle : messages.signupToggle);
	}

	if (!ctaText) {
		ctaText = formatMessage(authPrompt === 'login' ? genericMessages.signup : genericMessages.login);
	}

	return (
		<Wrapper data-testid={testId}>
			{toggleText}{' '}
			<Cta onClick={handleClick} data-testid={`${testId}-button`}>
				{ctaText}
			</Cta>
		</Wrapper>
	);
}
